import { render, staticRenderFns } from "./why.vue?vue&type=template&id=b815526c&scoped=true"
import script from "./why.vue?vue&type=script&lang=js"
export * from "./why.vue?vue&type=script&lang=js"
import style0 from "./why.vue?vue&type=style&index=0&id=b815526c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b815526c",
  null
  
)

export default component.exports